import { SearchTypes } from './SearchTypes';

/** Fields persisted on user.defaultFilters for jobs index (pooler & dispo). */
export type JobsDefaultFilterFieldValues = {
  state: string;
  createdBy: string | null;
  shift: string | null;
  branch: string | null;
  certificates: string | null;
  departments: string | null;
  jobType: string | null;
  demandReason: string | null;
  range: string | null;
} & { [key in SearchTypes]: string | null };

export function getEmptyJobsDefaultFilter(
  state: string,
): JobsDefaultFilterFieldValues {
  return {
    state,
    createdBy: null,
    shift: null,
    branch: null,
    certificates: null,
    departments: null,
    jobType: null,
    demandReason: null,
    range: null,
    ALL: null,
    DESCRIPTION: null,
    USER: null,
    BOOKED_USER: null,
    CANCELED_USER: null,
    SHIFT: null,
  };
}

export function getJobsDefaultFilterSaveParams(
  state: string,
  queryParams: Record<string, string | undefined | null>,
): JobsDefaultFilterFieldValues & Record<string, string | undefined | null> {
  return {
    ...getEmptyJobsDefaultFilter(state),
    ...queryParams,
  };
}

export type SavedJobsDefaultFilterParams = Partial<
  Omit<JobsDefaultFilterFieldValues, 'state'>
> &
  Pick<JobsDefaultFilterFieldValues, 'state'>;

export function omitNullJobsDefaultFilterValues(
  params: JobsDefaultFilterFieldValues,
): SavedJobsDefaultFilterParams {
  const result: SavedJobsDefaultFilterParams = { state: params.state };

  for (const key of Object.keys(params) as Array<keyof JobsDefaultFilterFieldValues>) {
    if (key === 'state') continue;
    const value = params[key];
    if (value !== null) {
      result[key] = value;
    }
  }

  return result;
}

/** Drop legacy uppercase DEPARTMENT search key when applying saved defaults. */
export function normalizeJobsDefaultFilterForLoad(
  filter: Record<string, string | undefined>,
): Record<string, string | undefined> {
  const { DEPARTMENT: _legacyDepartment, ...rest } = filter;
  return rest;
}
